import React from "react";
import {Form, Nav, Pagination} from "@themesberg/react-bootstrap";

const PagingFooter = (props) => {
    const {totalElements, totalPages, currentPage, numberOfElements, last, first, onClick} = props;

    const renderPaginationItems = () => {
        const items = [];
        const maxPagesToShow = 7;

        if (!totalPages || totalPages === 0) {
            return items;
        }

        if (totalPages <= maxPagesToShow) {
            // Show all pages if total is small
            for (let i = 0; i < totalPages; i++) {
                items.push(
                    <Pagination.Item
                        key={`page-${i}`}
                        active={currentPage === i}
                        onClick={() => onClick(i)}
                    >
                        {i + 1}
                    </Pagination.Item>
                );
            }
        } else {
            // Always show first page
            items.push(
                <Pagination.Item
                    key="page-0"
                    active={currentPage === 0}
                    onClick={() => onClick(0)}
                >
                    1
                </Pagination.Item>
            );

            // Determine the range of pages to show
            let startPage, endPage;

            if (currentPage <= 3) {
                // Near the beginning
                startPage = 1;
                endPage = 4;
            } else if (currentPage >= totalPages - 4) {
                // Near the end
                startPage = totalPages - 5;
                endPage = totalPages - 1;
            } else {
                // In the middle
                startPage = currentPage - 1;
                endPage = currentPage + 1;
            }

            // Add ellipsis after first page if needed
            if (startPage > 1) {
                items.push(<Pagination.Ellipsis key="ellipsis-start" disabled />);
            }

            // Add middle pages
            for (let i = startPage; i <= endPage; i++) {
                items.push(
                    <Pagination.Item
                        key={`page-${i}`}
                        active={currentPage === i}
                        onClick={() => onClick(i)}
                    >
                        {i + 1}
                    </Pagination.Item>
                );
            }

            // Add ellipsis before last page if needed
            if (endPage < totalPages - 2) {
                items.push(<Pagination.Ellipsis key="ellipsis-end" disabled />);
            }

            // Always show last page
            items.push(
                <Pagination.Item
                    key={`page-${totalPages - 1}`}
                    active={currentPage === totalPages - 1}
                    onClick={() => onClick(totalPages - 1)}
                >
                    {totalPages}
                </Pagination.Item>
            );
        }

        return items;
    };

    return (
        <>
            <Nav>
                <Pagination className="mb-2 mb-lg-0">
                    <Pagination.Prev disabled={first} onClick={() => onClick((currentPage - 1))}>
                        Previous
                    </Pagination.Prev>
                    {renderPaginationItems()}
                    <Pagination.Next disabled={last} onClick={() => onClick((currentPage + 1)) }>
                        Next
                    </Pagination.Next>
                </Pagination>
            </Nav>
            <small className="fw-bold">
                Showing <b>{numberOfElements}</b> out of <b>{totalElements}</b> entries
            </small>
        </>
    );
}

const PagingSize = (props) => {
    const {selectedSized, onChange} = props;
    return (
        <>
            <Form.Select aria-label="Page size" onChange={({target}) => onChange(target.value)}>
                <option selected disabled>Page Size</option>
                <option value="25" selected={selectedSized === 25}>25</option>
                <option value="100" selected={selectedSized === 100}>100</option>
                <option value="500" selected={selectedSized === 500}>500</option>
                <option value="1000" selected={selectedSized === 1000}>1000</option>
                <option value="5000" selected={selectedSized === 5000}>5000</option>
            </Form.Select>
        </>
    );
}

export {
    PagingFooter,
    PagingSize,
};
